import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
        <i className="ri-compass-3-line text-3xl" />
      </span>
      <p className="mt-8 font-heading text-6xl font-extrabold text-primary-500 md:text-7xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        Page not found
      </h1>
      <p className="mt-2 max-w-md text-sm text-foreground-600">
        The page you are looking for does not exist or may have been moved.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-home-4-line text-base" />
        {t("article.breadcrumbHome")}
      </Link>
    </div>
  );
}